export enum CreatorTagsMode {
  Exclude = "exclude",
  Include = "include",
}
